import { defineComponent as _defineComponent } from 'vue';
import { onMounted } from "vue";
import { useHistoryStore } from "@/stores/historyStore";
import { refreshContentsWrapper } from "@/utils/data";
import Webhooks from "@/utils/webhooks";
import GridInvocation from "@/components/Grid/GridInvocation.vue";
import WorkflowInvocationState from "@/components/WorkflowInvocationState/WorkflowInvocationState.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRunSuccess',
    props: {
        workflowName: null,
        invocations: null
    },
    setup(__props) {
        var _a;
        const props = __props;
        onMounted(() => {
            new Webhooks.WebhookView({
                type: "workflow",
                toolId: null,
                toolVersion: null,
            });
            refreshContentsWrapper();
        });
        const historyStore = useHistoryStore();
        const targetHistories = props.invocations.reduce((histories, invocation) => {
            if (invocation.history_id && !histories.includes(invocation.history_id)) {
                histories.push(invocation.history_id);
            }
            return histories;
        }, []);
        const wasNewHistoryTarget = props.invocations.length > 0 &&
            !!((_a = props.invocations[0]) === null || _a === void 0 ? void 0 : _a.history_id) &&
            historyStore.currentHistoryId !== props.invocations[0].history_id;
        return { __sfc: true, props, historyStore, targetHistories, wasNewHistoryTarget, GridInvocation, WorkflowInvocationState };
    }
});
